// extracted by mini-css-extract-plugin
export default {"comment-content":"Content_comment-content__MH4F7"};